import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { clearUserTransactions } from '../store/transactionsSlice';
import { useUser } from '@clerk/clerk-react';
import { motion, AnimatePresence } from 'framer-motion';
import { AppDispatch } from '../store';

export const CleanupButton = () => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useUser();
  const [showSuccess, setShowSuccess] = useState(false);

  const handleCleanup = async () => {
    if (!user) {
      alert('You must be logged in to clear transactions');
      return;
    }

    console.log('Current user ID:', user.id); // Debug log

    if (window.confirm('Are you sure you want to clear all transactions? This cannot be undone.')) {
      try {
        setIsLoading(true);
        console.log('Attempting to clear transactions for user:', user.id); // Debug log
        const result = await dispatch(clearUserTransactions(user.id)).unwrap();
        console.log('Clear transactions result:', result); // Debug log
        setShowSuccess(true);
        setTimeout(() => {
          setShowSuccess(false);
        }, 3000);
        alert('Successfully cleared all transactions');
      } catch (error) {
        console.error('Error clearing transactions:', error);
        // More detailed error message
        alert(error instanceof Error ? `Failed to clear transactions: ${error.message}` : 'Failed to clear transactions');
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      <button
        onClick={handleCleanup}
        disabled={isLoading}
        className="block w-full py-3 bg-red-500 text-white text-center
                 text-lg rounded-full cursor-pointer
                 border-2 border-red-700 shadow-[4px_4px_0px_0px_#B91C1C]
                 hover:bg-red-500/90 active:translate-x-[4px] active:translate-y-[4px] 
                 active:shadow-none transition-all duration-200 disabled:opacity-50"
      >
        {isLoading ? 'Clearing...' : 'Clear All Transactions'}
      </button>

      {/* Success Message */}
      <AnimatePresence>
        {showSuccess && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="fixed top-6 left-1/2 -translate-x-1/2 bg-white px-6 py-4 rounded-xl
                     shadow-brutal border-2 border-black z-50"
          >
            <div className="flex items-center gap-3">
              <svg
                className="w-6 h-6 text-green-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
              <p className="font-medium text-purple-dark">
                Transactions cleared successfully
              </p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
